import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Navigate, useLocation } from 'react-router-dom';
import useGetRedirectPath from 'routing/useGetRedirectPath';

import { useAuthenticatedContext } from 'hooks/useAuthenticated';

import * as Styled from './AccessDeniedPage.styles';

const AccessDeniedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const getRedirectPath = useGetRedirectPath();
  const location = useLocation();
  const { currentUser } = useAuthenticatedContext();

  return location.pathname.includes('/login') || currentUser === null ? (
    <Navigate to={getRedirectPath} />
  ) : (
    <Styled.Layout>
      <Styled.PageTitle>{t('accessDeniedPage.accessDenied')}</Styled.PageTitle>
      <Button
        data-cy="error404-backToHome"
        type="primary"
        onClick={() => navigate(getRedirectPath)}
      >
        {t('accessDeniedPage.backToHome')}
      </Button>
    </Styled.Layout>
  );
};

export default AccessDeniedPage;
